import { render, staticRenderFns } from "./Headings.vue?vue&type=template&id=3e8f7d4c&scoped=true&"
import script from "./Headings.vue?vue&type=script&lang=js&"
export * from "./Headings.vue?vue&type=script&lang=js&"
import style0 from "./Headings.vue?vue&type=style&index=0&id=3e8f7d4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f7d4c",
  null
  
)

export default component.exports